import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

function isoDaysAgo(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState("all");
  const [dateFrom, setDateFrom] = useState(isoDaysAgo(90));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));
  const [settings, setSettings] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setAuthChecked(true);
    }
  }, []);

  const refreshDepartments = useCallback(async () => {
    try {
      const res = await api.get("/departments");
      setDepartments(res.data);
    } catch (e) {}
  }, []);

  const refreshSettings = useCallback(async () => {
    try {
      const res = await api.get("/settings");
      setSettings(res.data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setAuthChecked(true);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (user) {
      refreshDepartments();
      refreshSettings();
    }
  }, [user, refreshDepartments, refreshSettings]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
    window.location.href = "/login";
  };

  const deptName = (id) => departments.find((d) => d.id === id)?.name || "—";

  return (
    <AppContext.Provider
      value={{
        user, setUser, authChecked, checkAuth,
        departments, refreshDepartments, deptName,
        selectedDept, setSelectedDept,
        dateFrom, setDateFrom, dateTo, setDateTo,
        settings, refreshSettings, logout,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
